import * as React from 'react';


export default class Grid extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">       
        <g id="thumbView" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M1.467 3.4h13.066M1.467 8.067h13.066M1.467 12.733h13.066"/>
        </g>
      </svg>
    )
  }
}
